import { render, staticRenderFns } from "./DebtorDetail.vue?vue&type=template&id=707770ce"
import script from "./DebtorDetail.vue?vue&type=script&lang=js"
export * from "./DebtorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports